export default {
  warningText: {
    marginTop: '1em',
    marginBottom: '2em',
  },
  linkPading: {
    padding: '0px',
  },
};
